import React from "react";
import { RefundStyleChartCard } from "./RefundChartCard";
import { mergeExchangeModel } from "./dashboardChartsModel";

/**
 * Exchange — same chart + table + kebab as Refund (row 7, left).
 *
 * @param {object} props
 * @param {import("./dashboardChartsModel.js").CustomOrderChartModel | undefined} [props.model]
 * @param {() => void} [props.onMenuRemove]
 */
function ExchangeChartCard({ model, onMenuRemove }) {
  return (
    <RefundStyleChartCard
      model={model}
      onMenuRemove={onMenuRemove}
      mergeModel={mergeExchangeModel}
      titleKey="graphExchange"
      defaultTitle="Exchange"
      downloadPrefix="exchange"
      rowIdPrefix="ex"
      cardBem="exchange"
    />
  );
}

export default ExchangeChartCard;
